/**
 * Intercepts /cart/add fetch requests to:
 * 1. Inject line item properties from the ET picker and Custom Finish picker
 * 2. Block add-to-cart if required pickers have no selection
 */

let currentET = '';
let currentFinish = '';

window.addEventListener('et-picker:changed', (e) => {
  currentET = `ET${e.detail.et}`;
  // Clear validation state when user makes a selection
  const select = document.querySelector('et-picker select, wheel-configurator select[data-et-select]');
  if (select) select.classList.remove('picker-invalid');
});

window.addEventListener('finish-picker:changed', (e) => {
  currentFinish = e.detail.finish;
  const btn = document.querySelector('[data-finish-open], [data-role="wc-open-drawer"]');
  if (btn) btn.classList.remove('picker-invalid');
});

const originalFetch = window.fetch;
window.fetch = function (url, options) {
  if (typeof url === 'string' && url.includes('/cart/add') && options?.body) {
    // Check if pickers are on the page and require a selection
    const etSelect = document.querySelector('et-picker select, wheel-configurator select[data-et-select]');
    const finishInput = document.querySelector('finish-picker input[name="properties[Custom Finish]"], wheel-configurator input[data-finish-input]');

    const missing = [];
    if (etSelect && !currentET) {
      missing.push('ET Offset');
      etSelect.classList.add('picker-invalid');
      etSelect.focus();
    }
    if (finishInput && finishInput.value === '' && !currentFinish) {
      missing.push('Custom Finish');
      const btn = document.querySelector('[data-finish-open], [data-role="wc-open-drawer"]');
      if (btn) btn.classList.add('picker-invalid');
    }

    if (missing.length > 0) {
      // Block the cart-add and return a fake response so Horizon doesn't crash
      return Promise.resolve(new Response(
        JSON.stringify({ status: 422, message: `Velg ${missing.join(' og ')}`, description: `Velg ${missing.join(' og ')}` }),
        { status: 422, headers: { 'Content-Type': 'application/json' } }
      ));
    }

    // Inject properties into the request
    try {
      const body = JSON.parse(options.body);
      if (body.items) {
        body.items.forEach((item) => {
          if (currentET || currentFinish) {
            item.properties = item.properties || {};
            if (currentET) item.properties['ET Offset'] = currentET;
            if (currentFinish) item.properties['Custom Finish'] = currentFinish;
          }
        });
        options = { ...options, body: JSON.stringify(body) };
      }
    } catch {
      if (options.body instanceof FormData) {
        if (currentET) options.body.set('properties[ET Offset]', currentET);
        if (currentFinish) options.body.set('properties[Custom Finish]', currentFinish);
      }
    }
  }
  return originalFetch.apply(this, arguments);
};

// Inject validation styles
const style = document.createElement('style');
style.textContent = `
  .picker-invalid {
    border-color: #e53e3e !important;
    box-shadow: 0 0 0 1px #e53e3e;
    animation: picker-shake 0.4s ease;
  }
  @keyframes picker-shake {
    0%, 100% { transform: translateX(0); }
    20%, 60% { transform: translateX(-4px); }
    40%, 80% { transform: translateX(4px); }
  }
`;
document.head.appendChild(style);
